<template>
    <z-basePage :title="'任务设置'">
        <div class="tab-title">
            <div class="tab-btn" :class="{active:activeIndex==0}" @click="changeTab(0)">任务类型</div>
            <div class="tab-btn" :class="{active:activeIndex==1}" @click="changeTab(1)">接收时间</div> 
            <div class="tab-btn" :class="{active:activeIndex==2}" @click="changeTab(2)">审核条件</div> 
        </div>

        <div class="tab">
            <!-- 任务类型 -->
            <div class="tab-main" :class="{active:activeIndex == 0}">
                <div class="btns-top">
                    <div class="back-btn blue" @click="link(0)">创建</div>
                    <!-- <div class="back-btn red" :class="{disabled:deleteList.length==0}">删除</div> -->
                </div>
                <div class="back-list page">
                    <div class="list-head">
                        <!-- <el-checkbox v-model="allchoose"></el-checkbox> -->
                        <div>类型名称</div>
                        <div>类型说明</div>
                        <div>操作</div>
                    </div>
                    <z-scrollDiv class="main">
                        <div class="list-item"  v-for="item in taskTpl" :key="item.id">
                            <!-- <el-checkbox  v-model="checklist[index]"></el-checkbox> -->
                            <div>{{ item.tpl_name }}</div>
                            <div class="overhide">{{ item.tpl_description }}</div>
                            <div>
                                <span class="blue" @click="link(item.id)">编辑</span>
                                <!-- <span class="red" @click="deleteType(item.id)">删除</span> -->
                            </div>
                        </div>
                        <z-noData :list="taskTpl"></z-noData>
                    </z-scrollDiv>
                </div>
            </div>

            <!-- 任务时间 -->
            <div class="tab-main" :class="{active:activeIndex == 1}">
                <taskTime></taskTime>
            </div>

            <!-- 审核条件 -->
            <div class="tab-main" :class="{active:activeIndex == 2}">
                <taskExam></taskExam>
            </div>
        </div>

    </z-basePage>
</template>

<script>
    import taskTime from 'src/views/backEndStage/setting/taskTime.vue'
    import taskExam from 'src/views/backEndStage/setting/task-exam.vue'

    import { mapState,mapGetters } from "vuex";

    export default {
        components:{
            taskTime,
            taskExam,
        },
        data(){
            return{
            }
        },
        computed:{
            ...mapState(["taskTpl"]),
            activeIndex(){
                return this.$route.query.tab || 0;
            },
        },
        created(){
            this.$func.getTaskTpl(true);
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
            let res;
            if(this.activeIndex == 1){
			    res = this.$form.leave({name:'back-taskTime',path:to.path});
            }else if(this.activeIndex == 2){
                res = this.$form.leave({name:'back-taskExam',path:to.path});
            }
			next(res);
        },

        methods:{
            link(id){  //跳转
                let str = this.$crypto.encrypt(id);
                this.$router.push({
                    name:'back-setting-addTaskType',
                    params:{
                        id:str,
                    }
                })
            },
            changeTab(val){  //记录激活的tab序号
                this.$router.push({
                    name:'back-setting-taskType',
                    query:{
                        tab:val
                    },
                });
            },
            deleteType(id){  //删除任务类型
                // let url = `api/admin/task_tpl/${id}`;
                let url = `api/admin/task_tpl_delete/${id}`;
                this.$http.delete(url).then(res=>{
                    if(res.status == 200){
                        this.$func.getTaskTpl(true);
                        this.successTip("删除成功");
                    }
                }).catch(err=>{
                    this.errorTip("删除失败");
                });

            },

        }

    }
</script>

<style lang="less" scoped>
    .tab{
        position: relative;
        height: calc(~"100% - 30px - 10px");
        box-sizing: border-box;
        .tab-main{
            position: absolute;
            top:0;
            left: 0;
            width: 100%;
            opacity: 0;
            transition:0.3s;
            z-index:-1;
            height:100%;
            &.active{
                opacity:1;
                z-index:1;
            }
        }
    }

    // 列表布局
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 20%;
        }
        >div:nth-of-type(2){
            width: 50%;
        }
        >div:nth-of-type(3){
            width: 10%;
            padding-left: 20%;
            span{
                cursor: pointer;
                display: inline-block;
                &+span{
                    margin-left:10px;
                }
            }
        }
    }

</style>





// WEBPACK FOOTER //
// page-taskSetting.vue?5c20dcba